/** Sign-in URL that returns the user to restaurant games after login. */
export function gamesSignInPath(appName: string, gameType?: string): string {
  const gamesPath = gameType
    ? `/restaurants/${appName}/games/${gameType}`
    : `/restaurants/${appName}/games`;
  return `/signin?redirect=${encodeURIComponent(gamesPath)}`;
}
